import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAuthType, getClusterRoles, isUploadSecretKey } from '@/services/permissionsService';

const initialState = {
  authOptions: [],
  isUploadSecretKey: false,
  roleOptions: [],
};

export const fetchAuthType = createAsyncThunk('permissions/fetchAuthType', async () => {
  const response = await getAuthType();
  return response.data;
});

export const fetchIsUploadSecretKey = createAsyncThunk(
  'permissions/fetchIsUploadSecretKey',
  async (clusterName) => {
    const response = await isUploadSecretKey(clusterName);
    return response.data;
  },
);

// 角色下拉
export const fetchClusterRoleOptions = createAsyncThunk(
  'permissions/fetchClusterRoleOptions',
  async (params) => {
    const response = await getClusterRoles(params);
    return response.data;
  },
);

export const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuthType.fulfilled, (state, action) => {
        state.authOptions = (action.payload || []).map((item) => ({
          label: item,
          value: item,
        }));
      })
      .addCase(fetchIsUploadSecretKey.fulfilled, (state, action) => {
        state.isUploadSecretKey = action.payload;
      })
      .addCase(fetchClusterRoleOptions.fulfilled, (state, action) => {
        state.roleOptions = (action.payload || []).map((item) => ({
          label: item,
          value: item,
        }));
      });
  },
});

export default permissionsSlice.reducer;
